var exports = {
  "v": "delaySkeletonLoad__oMxnnd",
  "x": "showAfterDelay__3sx9SI",
};

module.exports = exports;
